import * as React from "react";

import * as R from "ramda";

interface DocVideoJWPlayerProps {
  coverImageURL?: string;
  hasCaptions: boolean;
  onVideoCompleteEvent?: () => void;
  onVideoPlayEvent?: (val: number) => void;
  shouldLoop: boolean;
  videoURL: string;
  subtitlesByLanguage: Record<string, string>;

  videoKey?: string; // TODO: GET RID OF?
}

interface DocVideoJWPlayerState {

}

interface Track {
  kind: "captions" | "subtitles",
  file: string,
  label: string,
  srclang?: string,
}

interface JwPlayerSettings {
  androidhls: boolean,
  playlist: Array<{
    image: string;
    sources: Array<{
      file: string
    }>;
    tracks?: Array<Track>
  }>
  repeat: boolean,
}

export const SUBTITLE_LANGUAGES = [
  {
    label: "English",
    lang: "en",
  },
  {
    label: "Spanish",
    lang: "es",
  },
];

function waitForJWPlayer(callback: () => void) {
  const interval = setInterval(() => {
    if (window.jwplayer) {
      clearInterval(interval);
      callback();
    }
  }, 50);
}

export default class DocVideoJWPlayer extends React.Component<DocVideoJWPlayerProps, DocVideoJWPlayerState> {
  constructor(props: DocVideoJWPlayerProps) {
    super(props);

    this.jwPlayerId = `jw-player-${Math.floor(Math.random() * 1000000000)}`;
    this.loggedCompletionOnce = false;
  }

  private jwPlayerId: string;
  private jwPlayer: any;
  private startTime?: number;
  private loggedCompletionOnce: boolean;

  componentDidMount() {
    const {
      coverImageURL,
      hasCaptions,
      onVideoPlayEvent,
      shouldLoop=false,
      videoURL,
      subtitlesByLanguage,
    } = this.props;

    waitForJWPlayer(() => {
      const jwplayerSettings: JwPlayerSettings = {
        "androidhls": true,
        "playlist": [{
          "image": coverImageURL || `${videoURL}/main_thumbnail.0000002.jpg`,
          "sources" : [{
            "file": `${videoURL}/index.m3u8`,
          },{
            "file": `${videoURL}/index.mpd`,
          },{
            "file": `${videoURL}/main.mp4`,
          }],
        }],
        "repeat": shouldLoop,
      };

      if (!R.isEmpty(subtitlesByLanguage)) {
        jwplayerSettings.playlist[0].tracks = Object.entries(subtitlesByLanguage).map(([srclang, fileName]) => ({
          "kind": "captions" as const,
          "file": `${videoURL}/${fileName}`,
          "label": SUBTITLE_LANGUAGES.find((lan) => lan.lang === srclang)?.label || srclang,
          "srclang": srclang,
        }));
      }

      this.jwPlayer = jwplayer(this.jwPlayerId).setup(jwplayerSettings);
      this.startTime = this.jwPlayer.getPosition();

      if (onVideoPlayEvent) {
        this.jwPlayer.on("play", this.handleJWPlayerPlay.bind(this));
        this.jwPlayer.on("pause", this.handleJWPlayerPause.bind(this));
        this.jwPlayer.on("complete", this.handleJWPlayerComplete.bind(this));
      }
    })
  }

  componentWillUnmount() {
    const {
      onVideoPlayEvent,
    } = this.props;

    if (onVideoPlayEvent && this.jwPlayer) {
      this.jwPlayer.off("play", this.handleJWPlayerPlay.bind(this));
      this.jwPlayer.off("pause", this.handleJWPlayerPause.bind(this));
      this.jwPlayer.off("complete", this.handleJWPlayerComplete.bind(this));
    }
  }

  handleJWPlayerPlay = () => {
    this.startTime = this.jwPlayer.getPosition();
  };

  handleJWPlayerPause = () => {
    const {
      onVideoPlayEvent,
      shouldLoop,
    } = this.props;

    if (!onVideoPlayEvent) { return; }

    if (shouldLoop && this.loggedCompletionOnce) { return; }

    onVideoPlayEvent(this.jwPlayerTimeDiff());
    this.startTime = this.jwPlayer.getPosition();
  };

  handleJWPlayerComplete = () => {
    const {
      onVideoPlayEvent,
      shouldLoop,
    } = this.props;

    if (!onVideoPlayEvent) { return; }

    if (shouldLoop && this.loggedCompletionOnce) { return; }

    onVideoPlayEvent(this.jwPlayerTimeDiff());
    this.startTime = this.jwPlayer.getPosition();

    if (this.props.onVideoCompleteEvent) {
      this.props.onVideoCompleteEvent();
    }

    this.loggedCompletionOnce = true;
  };

  jwPlayerTimeDiff = () => {
    const timeDiff = this.jwPlayer.getPosition() - (this.startTime || 0);
    return (timeDiff > 0 ? timeDiff : 0);
  };

  render() {
    return (
      <div>
        <div id={this.jwPlayerId} className="video-wrapper jw-player"/>
      </div>
    );
  }
}
